export const COOKIE_NAMES = {
  token: 'adminJwtToken',
  authCode: 'adminAuthCode',
  adminRole: 'adminRole',
  email: 'adminEmail',
}
